import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'MainNavigation';

export const useMainNavigationStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    height: '100%',
    width: '100%',
  },
  docIcon: {
    color: theme.palette.link.main,
    marginRight: theme.spacing(1),
  },
  linkText: {
    borderBottom: `1px solid ${alpha(theme.palette.link.main, 0.5)}`,
    transition: 'border-color 0.3s',
  },
  link: {
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(2),
    textDecoration: 'none',
    height: 24,
    width: 68,
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.palette.indigo.main,

    '&, &:visited': {
      color: theme.palette.link.main,
    },

    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.indigo.dark,
      textDecoration: 'none',

      span: {
        borderColor: theme.palette.link.main,
      },
    },
  },
  divider: {
    marginTop: 3,
    marginBottom: 3,
  },
  skeleton: {
    height: theme.spacing(6),
    margin: theme.spacing(6, 3),

    borderRadius: theme.spacing(1.5),

    backgroundColor: theme.palette.background.default,
  },
  additionalOptions: {
    marginTop: theme.spacing(3),
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
}));
